import { FolderOutlined } from "@ant-design/icons";

interface SectionOptionLabelProps {
  name: string;
  /** Nesting depth (0 = top level), used to indent and draw a tree connector. */
  depth: number;
}

/**
 * Renders a section name indented by its depth with a tree connector and folder
 * icon, so the nesting is obvious in dropdown/select lists.
 */
export const SectionOptionLabel: React.FC<SectionOptionLabelProps> = ({
  name,
  depth,
}) => (
  <span className="flex items-center" style={{ paddingLeft: depth * 18 }}>
    {depth > 0 && <span className="text-gray-300 mr-1 select-none">└─</span>}
    <FolderOutlined className="text-yellow-500 mr-1.5" />
    <span className="truncate">{name}</span>
  </span>
);
